/*
 * Copyright (c) 2026 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Component imports
import { Checkbox, Form, Skeleton, Typography } from 'antd';

// Misc imports
import { useFetchBotQuery } from '../../../../store/bots/botsApi';

const { Text } = Typography;

const LogoutNodeForm = () => {
  const { t } = useTranslation();
  const { orgId, tenantId } = useParams();
  const { data: bot, isFetching: isFetchingBot } = useFetchBotQuery({ orgId, tenantId }, { skip: !tenantId });

  const hasOidcConfig = !!bot?.settings?.security?.oidc?.integration;

  if (isFetchingBot) {
    return <Skeleton active />;
  }

  return (
    <Fragment>
      <Text type="secondary" className="fs-sm mb-2 d-block">
        {t('Clears the authentication session and notifies the webchat.')}
      </Text>

      {hasOidcConfig && (
        <Fragment>
          <Form.Item
            name={['data', 'idpLogout']}
            valuePropName="checked"
            initialValue={false}
            className="mb-2"
          >
            <Checkbox>
              {t('Also sign out from identity provider')}
            </Checkbox>
          </Form.Item>

          <Text type="secondary" className="fs-sm">
            {t('When enabled, the bot will attempt to call the identity provider\'s logout endpoint. This is best-effort and errors are silently ignored.')}
          </Text>
        </Fragment>
      )}
    </Fragment>
  );
};

export default LogoutNodeForm;
